var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"g g_centralEditions",style:(_vm.styles)},[_c('layout-header',{on:{"ui":_vm.updateUi}}),_c('router-view'),_c('layout-footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }